function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "2DDDE361-2048-42E7-A76F-E1B935DF8F81");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Screens:-Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard_EmptyState",
  transform: "translate(-481.000000, -214.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Table",
  transform: "translate(120.000000, 152.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(272.000000, 62.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_PoolsEmpty",
  transform: "translate(89.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 54,
  height: 38
}), /*#__PURE__*/React.createElement("path", {
  d: "M34,0 C35.1045695,-2.02906125e-16 36,0.8954305 36,2 L36.0005294,4.20279583 C35.9184738,4.24641344 35.8389421,4.29704435 35.7627632,4.35466657 C34.7805678,5.09997617 33.2217827,6.35387376 31.5260101,7.99993088 L2,8 C0.8954305,8 1.3527075e-16,7.1045695 0,6 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L34,0 Z",
  id: "Combined-Shape",
  fillOpacity: 0.9,
  fill: "#BCD7F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6071569,20.0001725 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,14 C-1.3527075e-16,12.8954305 0.8954305,12 2,12 L27.9090285,11.999932 C26.0762336,14.3445847 24.4491975,17.0624684 23.6071569,20.0001725 Z",
  id: "Combined-Shape",
  fillOpacity: 0.6,
  fill: "#BCD7F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23,24.234905 C23,27.1135438 23.8914236,29.7887207 25.4135955,32.0006707 L2,32 C0.8954305,32 1.3527075e-16,31.1045695 0,30 L0,26 C-1.3527075e-16,24.8954305 0.8954305,24 2,24 L23.0008374,24.0000885 C22.9998943,24.0782648 22.9996121,24.1565378 23,24.234905 Z",
  id: "Combined-Shape",
  fillOpacity: 0.3,
  fill: "#BCD7F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.4001949,34 C43.4271079,34 47.8003898,29.4915155 47.8003898,23.2799991 C47.8003898,15.1782473 38.5468164,8.51952248 38.152909,8.24001725 C37.7005005,7.92021125 37.0985893,7.92021125 36.6500808,8.23871722 C36.2561735,8.51562241 27,15.1535468 27,23.274799 C27,29.4889155 31.373282,34 37.4001949,34 Z M37.4,10.6 C39.4865391,12.2770314 45.6612521,17.7158948 45.6612521,23.2799991 C45.6612521,28.0614887 42.012209,31.8593929 37.420523,31.8593929 C32.8288369,31.8593929 29.1797938,28.0640888 29.1797938,23.2799991 C29.1797938,17.7028946 35.3134609,12.2731314 37.4,10.6 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))));

var SvgIconPoolsEmpty = function SvgIconPoolsEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "38px",
    viewBox: "0 0 54 38",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPoolsEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_PoolsEmpty.ce39cee0.svg";
export { ForwardRef as ReactComponent };